export default __webpack_public_path__ + "static/jim_hibbard-00a18c8c85e4df6250780cfc8e34b566.jpg";